import React, { useEffect, useState } from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Breadcum from "../common/breadcum";
import {
  deleteProject,
  getProjectsByYear,
} from "../../services/projectService";
import Loading from "../common/loading";
import { notifications } from "../../utils/messages";
import ProjectYear from "./projectYear";
import ProjectsTableI from "./projectsTableI";

const currentYear = new Date().getFullYear().toString();

const ProjectsI = ({ history }) => {
  const [year, setYear] = useState(currentYear);
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const populateProjects = async (year) => {
    setIsLoading(true);
    const { data: projects } = await getProjectsByYear(year);
    setProjects(projects);
    setIsLoading(false);
  };

  useEffect(() => {
    populateProjects(year);
  }, [year]);

  const handleDelete = async (projectSlug) => {
    const originalProjects = [...projects];
    const newProjects = originalProjects.filter(
      (project) => project.slug !== projectSlug
    );
    setProjects(newProjects);
    try {
      await deleteProject(projectSlug);
      enqueueSnackbar(notifications.DELETE_SUCCESS, {
        variant: "success",
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        this.props.enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      } else if (ex.response.status === 403) {
        this.props.enqueueSnackbar(`${ex.response.data.message}`, {
          variant: "error",
        });
      }
      setProjects(originalProjects);
    }
  };

  const handleChangeSelected = (event, values, nameSelect) => {
    setYear(values);
  };

  return (
    <Container maxWidth="xl">
      <Loading open={isLoading} />
      <Breadcum lastLabel={"Proyectos"} />
      <Grid item xs={12} sm={6} md={4} lg={3} style={{ marginBottom: "1em" }}>
        <Typography variant="h6" gutterBottom>
          Seleccione un año:
        </Typography>
        <ProjectYear
          selectedYear={year}
          onChangeSelect={handleChangeSelected}
        />
      </Grid>

      <ProjectsTableI
        datas={projects}
        onDelete={handleDelete}
        history={history}
      />
    </Container>
  );
};

export default ProjectsI;
